import { __GetContentTypeConfigNew } from "@/utils/getters/gettersV2";
import { getSmallestBatchSize, mergeCsvExportArraysFromContentTypes } from "@/utils/general";
import { useGetExportToCsvContent } from "@/utils/react-query-hooks/exportToCsv";


export const useDataExport = ({
  activeFilters = [],
  presetActiveFilters = [],
  contentTypes,
  getDataConfig = {},
  findQuery,
  searchTermInputValue
}) => {
  const commonDataExportArgs = {
    activeFilters: [...presetActiveFilters, ...activeFilters],
    resourceType: contentTypes,
    ...getDataConfig,
    findQuery: searchTermInputValue ? {} : findQuery,
    populateTagsArray: mergeCsvExportArraysFromContentTypes({
      contentTypes,
      propertyPath: 'populateTagsArray'
    }),
    fieldsToSortAtEnd: mergeCsvExportArraysFromContentTypes({
      contentTypes, 
      propertyPath: 'fieldsToSortAtEnd'
    }),  
    enableUpdateExport: contentTypes?.some(type => 
      __GetContentTypeConfigNew(type)?.general.csvExport?.enableUpdateExport
    ) || false,
    isBatchDownload: contentTypes?.some(type => 
      __GetContentTypeConfigNew(type)?.general.csvExport?.fetchBatches.enable
    ) || false,
    batchSize: contentTypes?.some(type => 
      __GetContentTypeConfigNew(type)?.general.csvExport?.fetchBatches.batchSize
    ) ? getSmallestBatchSize(contentTypes) : 0
  };
  
  const { refetch: csvRefetch } = useGetExportToCsvContent({
    ...commonDataExportArgs
  });

  const { refetch: jsonRefetch } = useGetExportToCsvContent({
    ...commonDataExportArgs,
    dataFormat: "json",  
  });

  const getDataToBeExported = async ({ dataFormat }) => {
    if (dataFormat === 'json') {
      const response = await jsonRefetch();
      return response;
    } else if (dataFormat === 'csv') {
      const response = await csvRefetch();
      return response;
    }
  };

  return {
    getDataToBeExported,
    csvRefetch,
    jsonRefetch
  };
};